import { render, staticRenderFns } from "./create-password-form.vue?vue&type=template&id=d6bb810a&lang=pug&"
import script from "./create-password-form.vue?vue&type=script&lang=js&"
export * from "./create-password-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports